import "./notFound.css";
import { GuestHeader, Panel } from "../../components";
import { ArrowRightFill } from "../../assets";

const NotFoundScreen: React.FC<{ isLoggedIn: boolean }> = ({ isLoggedIn }) => {
  return (
    <Panel header={isLoggedIn}>
      {!isLoggedIn && <GuestHeader />}

      <div className="notfound-wrapper">
        <h2 className="notfound-title">404</h2>
        <p className="notfound-description">Página no encontrada</p>

        <a className={`notfound-button`} href="/">
          <img
            src={ArrowRightFill}
            alt="Icon arrow right"
            className="notfound-button-icon"
          />
          <p>Inicio</p>
        </a>
      </div>
    </Panel>
  );
};

export default NotFoundScreen;
